import { Routes as ListRoutes, Route, Navigate } from "react-router-dom";
import Login from "./Login";
import SignUp from "./SignUp";
import Instructions from "./Instructions";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/AppContext";
import Header from "./Header";
import Footer from "./Footer";
import AdminScreenSharing from "./ScreenSharing";
import Dashboard from "./Dashboard";
import IpSetup from "./IpSetup";
import Users from "./Users";
import Group from "./Group";
import TimeTracker from "./TimeTracker";
import Settings from "./Settings";
import Department from "./Department";
import { getAppData } from "../services/authServices"
import ViewProfile from "./ViewProfile.js";
import { Screenshots } from "./Screenshots.js";
import { Chat } from "./Chat.js";
import { checkPermission } from "../helper/helper.js";
import ExternalRedirect from "./ExternalRedirect.js";
import WarningLogs from "./Warning.js";

function Routes() {
  const { setLogin, login, appData, setAppData } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(true);

  const getAppDetails = async () => {
    try {
      let result = await getAppData()
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const expiryDate = new Date(result.data.expiryDate);
      const timeDifference = expiryDate - today;
      const daysLeft = Math.floor(timeDifference / (1000 * 3600 * 24));
      let expired = daysLeft < 0;
      setAppData({ ...result.data, expired, daysLeft })
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log(error)
    }
  }

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("userData");
    if (token && userData) {
      setLogin({
        ...login,
        isLogin: true,
        token,
        user: JSON.parse(userData),
      });
    }
    getAppDetails()
    setIsLoading(false);
  }, []);

  useEffect(() => {
    const validPrefixes = ["/", "/#"];
    const currentPath = window.location.pathname;

    if (!validPrefixes.includes(currentPath)) {
      window.location.replace("https://prabhuchat.com");
    }
  }, []);

  if (isLoading) {
    return <div>Loading...</div>; // Show a loading indicator until login is initialized
  }


  return (
    <div>
      {Object.keys(appData).length > 0 && <>
        {login.isLogin && <Header />}
        {window.electronAPI?.isElectron ? (
          <ListRoutes>
            {login.isLogin ? (
              <>
                <Route path="/" element={<Dashboard />} />
                {checkPermission(login.user, "usergroup:create_update") && <Route path="/users" element={<Users />} />}
                {checkPermission(login.user, "usergroup:create_update") && <Route path="/groups" element={<Group />} />}
                <Route path="/screen-sharing" element={<AdminScreenSharing />} />
                <Route path="/config-settings" element={<Instructions />} />
                {checkPermission(login.user, "timetracking:read") && <Route path="/tracker" element={<TimeTracker />} />}
                {checkPermission(login.user, "timetracking:read") && <Route path="/warnings" element={<WarningLogs />} />}
                {checkPermission(login.user, "screenshot:read") && <Route path="/screenshots" element={<Screenshots />} />}
                {checkPermission(login.user, "chat:view") && <Route path="/chat" element={<Chat />} />}
                {checkPermission(login.user, "usergroup:create_update") && <Route path="/department" element={<Department />} />}
                {checkPermission(login.user, "usergroup:create_update") && <Route path="/viewUser/:id" element={<ViewProfile />} />}
                {checkPermission(login.user, "settings:read") && <Route path="/settings" element={<Settings />} />}
                <Route path="*" element={<ExternalRedirect />} />
              </>
            ) : (
              <>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/config-settings" element={<Instructions />} />
                <Route path="*" element={<ExternalRedirect />} />
              </>
            )}
          </ListRoutes>
        ) : (
          <>
            {!localStorage.getItem("ipConfig") ? (
              <IpSetup />
            ) : (
              <ListRoutes>
                {login.isLogin ? (
                  <>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/screen-sharing" element={<AdminScreenSharing />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/viewUser/:id" element={<ViewProfile />} />
                    <Route path="/groups" element={<Group />} />
                    <Route path="/tracker" element={<TimeTracker />} />
                    <Route path="/screenshots" element={<Screenshots />} />
                    <Route path="/warnings" element={<WarningLogs />} />
                    <Route path="/chat" element={<Chat />} />
                    <Route path="/department" element={<Department />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="*" element={<ExternalRedirect />} />
                  </>
                ) : (
                  <>
                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<SignUp />} />
                    <Route path="*" element={<ExternalRedirect />} />
                  </>
                )}
              </ListRoutes>
            )}
          </>
        )}
        {login.isLogin && <Footer />}
      </>}
    </div>
  );
}

export default Routes;
